import {Component, EventEmitter, inject, OnInit, Output, QueryList, ViewChildren} from '@angular/core';
import {MatExpansionPanel} from "@angular/material/expansion";
import {select, Store} from "@ngrx/store";
import {selectMappedStoreItems, selectStoreItems} from "../../../../store/entities/store-item/store-item.selectors";
import {StoreItemEntity} from "../../../../store/entities/store-item/store-item.model";
import {map, Observable} from "rxjs";
import {AppState} from "../../../../store/reducers";
import {
  FrequentlyAskedQuestion
} from "../../../../store/entities/frequently-asked-question/frequently-asked-question.model";
import {StoreItemActions} from "../../../../store/entities/store-item/store-item.actions";
import {
  GET_FREQUENTLY_ASKED_QUESTION_QUERY
} from "../../../../store/entities/frequently-asked-question/frequently-asked-question.graphql";
import {GET_CONTACT_CENTERS} from "../../../../store/entities/cms/contact-centers/contact-centers.graphql";
import {ContactCenter} from "../../../../store/entities/cms/contact-centers/contact-centers.model";

@Component({
  selector: 'app-faq-general-page',
  templateUrl: './faq-general-page.component.html',
  styleUrl: './faq-general-page.component.scss'
})
export class FaqGeneralPageComponent implements OnInit {


  openedFaq: number = -1
  store = inject(Store<AppState>);
  faqs$: Observable<FrequentlyAskedQuestion[]>
  contactCenters$: Observable<ContactCenter[]>;
  systemContactCenter$: Observable<ContactCenter>;
  msaadaAiToggle: boolean = false;

  @ViewChildren(MatExpansionPanel) panels!: QueryList<MatExpansionPanel>;
  weekdayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  changePanelState() {
    let expandedIndex: number = -1
    this.panels.forEach((panel, idx) => {
      if (panel.expanded) {
        expandedIndex = idx
      }
    });

    this.openedFaq = expandedIndex !== -1 ? expandedIndex : -1
  }

  sortSchedules(schedules: any[]) {
    const weekdayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    return schedules.slice().sort(
      (a, b) => weekdayOrder.indexOf(a.weekday) - weekdayOrder.indexOf(b.weekday)
    );
  }



  ngOnInit() {
    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      entity: StoreItemEntity.faqs,
      query: GET_FREQUENTLY_ASKED_QUESTION_QUERY,
      filtering: {}
    }))
    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      entity: StoreItemEntity.contactCenter,
      query: GET_CONTACT_CENTERS,
      filtering: {}
    }));

    this.faqs$ = this.store.pipe(select(selectStoreItems(StoreItemEntity.faqs)));
    this.contactCenters$ = this.store.pipe(select(selectMappedStoreItems(StoreItemEntity.contactCenter, (contactCenter: ContactCenter)=>{
      return {
        ...contactCenter,
        institutionName: contactCenter.institution.institutionName,
      }
    })));

    this.systemContactCenter$ = this.contactCenters$.pipe(
      map(centers => centers.find(c => c.isSystemContact === true))
    );
  }

  getSocialMediaIcon(platform: string): string {
    const iconMap = {
      Facebook: 'facebook',
      Twitter: 'x',
      Instagram: 'instagram_coloured',
      Linkedin: 'linkedin_coloured',
      Youtube: 'youtube_coloured',
      Whatsapp: 'whatsapp_coloured',
      Telegram: 'telegram_coloured',
      Tiktok: 'tiktok_coloured',
      Other: 'globe'
    };
    return iconMap[platform] || 'globe';
  }
  showAiIframe = false;

  toggleAiIframe() {
    this.showAiIframe = !this.showAiIframe;
  }


}
